import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import i18n from "../../api/i18n";
//import NaviMenu from "./NaviMenu";
import NavItem from "./NavItem";
import { ReactComponent as Chevron } from "../../assets/chevron.svg";
import { ReactComponent as GlobeIcon } from "../../assets/lang.svg";
//import {AcademyHome} from "../../assets/Menu/academy-home.svg";

import "../../stylesheet/components/navbar/NavBar.scss";
import setLang from "../../redux/reducers/lang";

type NavItemsProps = {
  //pathname: string;
  extraClass?: string;
  clickToCloseMenu: () => void;
};

type LanguageInfo = {
  code: string;
  name: string;
  dir: string; // or "ltr" | "rtl" if you're feeling fancy
};

export const NavItems: React.FC<NavItemsProps> = ({
  //pathname,
  extraClass,
  clickToCloseMenu,
}) => {
  //const dropContent = useRef<HTMLDivElement>(null);
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const { languages } = useSelector(
    (state: { language: { languages: LanguageInfo[] } }) => state.language
  );

  // Handle click on the dropdown button to show dropdown content
  // const handleClickDropBtn = () => {
  //   if (dropContent.current) dropContent.current?.classList.toggle("hidden");
  // };

  const currentLanguageCode = cookies.get("i18next") || "en";
  const currentLanguage = languages?.find(
    (l: LanguageInfo) => l.code === currentLanguageCode
  );
  //console.log("yy", currentLanguageCode);
  const [lang, setLanguage] = useState(currentLanguageCode);

  const { t, ready } = useTranslation();

  const desktopHandleLanguageChange = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    // console.log(
    //   "Change language to:",
    //   event.currentTarget.getAttribute("data-lang")
    // );
    const langChoice = event.currentTarget.getAttribute("data-lang");
    setLanguage(langChoice);
    i18n.changeLanguage(langChoice);
    // localStorage.setItem("language", langChoice);
    //changeUrlParam();
    setLang(langChoice);
  };

  const mobileHandleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    //console.log("Change language to:", event.currentTarget.value);
    const langChoice = event.currentTarget.value;
    setLanguage(langChoice);
    i18n.changeLanguage(langChoice);
  };

  //RTL UseEffect & Set name of the current-lang
  useEffect(() => {
    // const currentLanguageName = currentLanguage.name;
    document.body.dir = currentLanguage?.dir || "ltr";
    document.documentElement.lang = currentLanguage?.code || "ar";
  });

  //Change the url path to specific language
  // function changeUrlParam() {
  //   // history.replace(url.join("/"));
  //   //history.replace(localStorage.getItem("language"));
  // }

  // Toggle dropdown menu
  // useEffect(() => {
  //   // Toggle hidden menu dropdown content when goes into ipad size
  //   window.addEventListener("resize", () => {
  //     if (window.innerWidth < 1024) {
  //       if (dropContent.current) dropContent.current.classList.add("hidden");
  //     } else {
  //       if (dropContent.current) dropContent.current.classList.remove("hidden");
  //     }
  //   });
  // }, []);
  // {
  //   ready ? (
  //     t("navbar.sections")
  //   ) : (
  //     <div className="skeleton-text-row">
  //       <Skeleton />
  //     </div>
  //   );
  // }

  return (
    <div className={`nav-items${extraClass ? extraClass : ""}`}>
      <div className="nav-left">
        {ready ? (
          <NavItem
            title={t("navbar.zeacademy")}
            catalogue={t("navbar.course-catalogue")}
            path="academy"
            clickToCloseMenu={clickToCloseMenu}
            //Icon={AcademyHome}
          />
        ) : (
          <Skeleton width={100} />
        )}
        {ready ? (
          <NavItem
            title={t("navbar.zecafe")}
            path="cafe"
            clickToCloseMenu={clickToCloseMenu}
          />
        ) : (
          <Skeleton width={100} />
        )}
        {ready ? (
          <Link
            onClick={clickToCloseMenu}
            style={{ padding: "1rem" }}
            className="nav-item "
            to={`/${i18n.language}/about`}
          >
            {" "}
            {t("navbar.about")}
          </Link>
        ) : (
          <Skeleton width={100} />
        )}
        {ready ? (
          <Link
            onClick={clickToCloseMenu}
            style={{ padding: "1rem" }}
            className="nav-item "
            to={`/${i18n.language}/people`}
          >
            {" "}
            {t("navbar.zepeople")}
          </Link>
        ) : (
          <Skeleton width={100} />
        )}
        {/* <div data-testid="header-dropdown" className="nav-item dropdown">
          <div onClick={handleClickDropBtn} className="drop-btn">
            {ready ? (
              t("navbar.sections")
            ) : (
              <div className="skeleton-text-row">
                <Skeleton />
              </div>
            )}{" "}
            <Chevron className="icon mx-1" />
          </div>
          <div ref={dropContent} className="dropdown-content">
            <Link onClick={clickToCloseMenu} to={`/${i18n.language}/`}>
              {" "}
              {t("navbar.zefi")}
            </Link>
            <Link onClick={clickToCloseMenu} to={`/${i18n.language}/academy`}>
              {t("navbar.zeacademy")}
            </Link>
            <Link onClick={clickToCloseMenu} to={`/${i18n.language}/cafe`}>
              {" "}
              {t("navbar.zecafe")}
            </Link>
          </div>
        </div> */}
        {/* <NaviMenu clickToCloseMenu={clickToCloseMenu} path={pathname} /> */}
      </div>
      <div className="nav-right">
        <div data-testid="header-dropdown" className="nav-item dropdown">
          <div className="drop-btn">
            <GlobeIcon className="icon mx-1" />{" "}
            <span
              id="current-lang"
              // style={currentLanguage.code == "en" ? {marginBottom: "0px"} : {marginBottom: "-5px"}}
            >
              {currentLanguage.code == "en" ? "English" : "العربية"}
            </span>
            <Chevron className="icon mx-1" />
          </div>
          <div className="dropdown-content">
            <a onClick={desktopHandleLanguageChange} data-lang="ar">
              العربية
            </a>
            <a onClick={desktopHandleLanguageChange} data-lang="en">
              English
            </a>
          </div>
        </div>
        <div className="nav-right__mobile-menu-container">
          <div onClick={() => handleClick} id="language" className="link-icon">
            <GlobeIcon className="icon" />{" "}
            <form>
              <select
                id="lang-select"
                onChange={mobileHandleLanguageChange}
                value={lang}
              >
                {languages?.map(({ code }) => (
                  <option key={code} value={code}>
                    {code == "en" ? "English" : "العربية"}
                  </option>
                ))}
              </select>
            </form>
          </div>
        </div>
        {/*<a href="/" className="p-2">*/}
        {/*  Log In*/}
        {/*</a>*/}
        {/*<div className="d-flex align-items-center p-2">*/}
        {/*  <Button name="Sign Up" />*/}
        {/*</div>*/}
      </div>
    </div>
  );
};
